module.exports = __webpack_public_path__ + "img/14.ddd5c04f.jpg";